import PowerbiVariance from "@/pages/admin/powerbi-variance/PowerbiVariance.vue";

const powerbiVarianceRoutes = [
  {
    path: "powerbi-variance",
    name: "app-admin-powerbi-variance",
    component: PowerbiVariance,
  },
];

export default powerbiVarianceRoutes;
